angular.module('unergie.main')
.directive('admincomments', ($uibModal, AdminComments, ErrorCatcher) => ({
    restrict: 'E',
    templateUrl: '/directives/admincomments/admincomments.html',
    scope: {
        object: '=',
        picto: '=',
        label: '@?',
        style: '=',
        prefixComment: '@?',
    },
    link($scope) {
        if (_.isEmpty($scope.label)) {
            $scope.label = 'Commentaires'
        }

        const refreshCommentsNb = () => {
            AdminComments.getComments({ object: $scope.object }).$promise
            .then((comments) => {
                $scope.comments = comments
            })
            .catch(ErrorCatcher)
        }

        refreshCommentsNb()

        $scope.nbComments = () => $scope.comments.length

        $scope.openCommentsModal = (object) => {
            const modalInstance = $uibModal.open({
                animation: true,
                backdrop: 'static',
                size: 'lg',
                controller: 'adminCommentsModalCtrl',
                templateUrl: '/states/adminCommentsModal/adminCommentsModal.html',
                resolve: {
                    object: () => object,
                    comments: () => $scope.comments,
                    prefixComment: () => $scope.prefixComment,
                },
            })
            modalInstance.closed.then(() => refreshCommentsNb())
        }
    },
}))
